import React from "react";
import { Outlet } from "react-router";
import { useUser } from "@/contexts/UserContext";

/**
 * Layout for system admin pages. Only users with system role 'ADMIN' can access.
 * Assumes current user info is available at /api/me and includes 'role'.
 */
export function SystemAdminLayout() {
  const { currentUser, isLoadingUser } = useUser();

  if (isLoadingUser) {
    return <div className="p-8 text-center">Loading…</div>;
  }

  if (!currentUser || !currentUser.user || currentUser.user.role !== 'ADMIN') {
    return <div className="p-8 text-center text-destructive">You must be a system admin to view this page.</div>;
  }

  return <Outlet />;
}
